import axios from 'axios'
import {CREATE, UPDATE, GET_LIST, GET_ONE, GET_MANY, GET_MANY_REFERENCE, UPDATE_MANY, DELETE, DELETE_MANY} from "react-admin";
import {noteAuthFailure} from "./session";

const METHOD_MAP = {
    [CREATE]: 'create',
    [UPDATE]: 'update',
    [DELETE]: 'delete',
    [DELETE_MANY]: 'deleteMany',
    [GET_LIST]: 'getList',
    [GET_ONE]: 'getOne',
    [GET_MANY]: 'getMany',
    [GET_MANY_REFERENCE]: 'getManyReference',
    [UPDATE_MANY]: 'updateMany',
};

function callDataProvider(dataProvider, fetchType, resource, params) {
    const method = METHOD_MAP[fetchType];
    if (!method) {
        return dataProvider[fetchType](resource, params);
    }
    return dataProvider[method](resource, params);
}

export function uploadFile(file, folder, fileName) {
    let formData = new FormData();
    formData.append("file", file);
    
    return axios.post(process.env.REACT_APP_SERVER + `/api/upload/${folder}`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
    }).catch(error => {
        // A 401 is the session ending, not this upload failing. Handled here so an
        // upload made after a session lapses does not leave the user stuck on a
        // form with an error they cannot act on.
        if (error && error.response) noteAuthFailure(error.response);
        throw error;
    })
}

const uploadMiddleware = (dataProvider) => (fetchType, resource, params) => {
    const promises = []
    if ((resource === "Application" || resource === "Record"|| resource === "Visit" || resource === "Post"  ) && (fetchType === CREATE || fetchType === UPDATE)) {
        const {data, ...rest_params} = params;

        if(params.data.photo && params.data.photo.rawFile instanceof File) {
           promises.push(uploadFile(data.photo.rawFile, 'photos').then(res => {
               params.data.photo = res.data.filePath
            })
           )
         }

        if(params.data.place && params.data.place.photo && params.data.place.photo.rawFile instanceof File) {
            promises.push(uploadFile(data.place.photo.rawFile, 'photos').then(res => {
                    params.data.place.photo = res.data.filePath
                })
            )
        }

        if(params.data.story && params.data.story.photos ) {
            for(const p of params.data.story.photos) {
                if(p.filePath && p.filePath.rawFile instanceof File) {
                    promises.push(uploadFile(p.filePath.rawFile, 'photos').then(res => {
                        p.filePath = res.data.filePath
                        })
                    )
                }
            }
        }

        if(params.data.story && params.data.story.files ) {
            for(const p of params.data.story.files) {
                if(p.filePath && p.filePath.rawFile instanceof File) {
                    // No filename argument: the server names the stored file,
                    // sanitising it and avoiding collisions. The third argument
                    // this used to pass was never read by uploadFile, and its
                    // "+" and "||" were mixed up in any case.
                    promises.push(uploadFile(p.filePath.rawFile, 'post_attachments').then(res => {
                            p.filePath = res.data.filePath
                        })
                    )
                }
            }
        }

        if(params.data.files ) {
            for(const p of params.data.files) {
                if(p.filePath && p.filePath.rawFile instanceof File) {
                    // As above: the filename argument is never read.
                    promises.push(uploadFile(p.filePath.rawFile, 'post_attachments').then(res => {
                            p.filePath = res.data.filePath
                        })
                    )
                }
            }
        }

        if(params.data.families) {
            for(const f of params.data.families) {
                if(f.photo && f.photo.rawFile instanceof File){
                    promises.push(uploadFile(f.photo.rawFile, 'photos').then(res => {
                        f.photo = res.data.filePath
                    }))
                }
            }
        }

        if ((resource === "Visit")) {
            if(params.data.expense && params.data.expense.rent && params.data.expense.rent.photo && params.data.expense.rent.photo.rawFile instanceof File) {
                promises.push(uploadFile(params.data.expense.rent.photo.rawFile, 'photos').then(res => {
                    params.data.expense.rent.photo = res.data.filePath
                    })
                )
            }

            if(params.data.livingCondition && params.data.livingCondition.photos ) {
                // forEach, not map: this runs for its effect on the array and
                // the promises, and discards whatever the callback returns.
                params.data.livingCondition.photos.forEach((p,i) => {
                    if(p && p.rawFile instanceof File) {
                        promises.push(uploadFile(p.rawFile, 'photos').then(res => {
                                params.data.livingCondition.photos[i] = res.data.filePath
                            })
                        )
                    } else {
                        params.data.livingCondition.photos[i] = ''
                    }
                })
            }

            if(params.data.visitPhotos) {
                for(const p of params.data.visitPhotos) {
                    if(p && p.filePath && p.filePath.rawFile instanceof File) {
                        promises.push(uploadFile(p.filePath.rawFile, 'photos').then(res => {
                                p.filePath = res.data.filePath
                            })
                        )
                    }
                }
            }
        }

        return Promise.all(promises).then(() => {
            return callDataProvider(dataProvider, fetchType, resource, {
                ...rest_params,
                data: {...data},
            });
        })
    }

    return callDataProvider(dataProvider, fetchType, resource, params);
};

export default uploadMiddleware;
